module.exports = require('./helpers/bundle-url').getBundleURL('1BiIG') + "logo-dark.ba5147f0.svg";